import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const usePipeTemplate = (props: { enabled?: boolean } = {}) =>
  useQuery<crmModels.IPipeTemplate[]>({
    queryKey: [crmConstants.queryKeys.PIPE_TEMPLATE],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/pipe/template',
          query: {
            type: 'CUSTOM'
          }
        })
      );

      return res?.data?.data;
    },
    enabled: props?.enabled
  });
